import { render, staticRenderFns } from "./fork_preview.vue?vue&type=template&id=0a51798c&"
import script from "./fork_preview.vue?vue&type=script&lang=js&"
export * from "./fork_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports